import { RentCalculator } from "../Apps/RentCalculator"

function AppRentCalculator() {

    return (
        <RentCalculator />
    )
}

export default AppRentCalculator

